<template>
  <div class="changefindpetinfo">
    <header-top :goBack="true" :mine='true'></header-top>
    <p class="addtext" ref="title">{{$t('changefindpetinfo.changefind')}}</p>
    <div class="main" ref="wrapper">
      <div style="height:900px;">
        <div class="title" v-if="false">
          <el-input
            v-model="title"
            :placeholder="$t('changefindpetinfo.enterTitle')"
            @change="changetitle"
            maxlength="20"
          ></el-input>
          <span class="danger" v-show="flag">{{$t('releaseSearch.nottitle')}}</span>
          <span class="danger" v-show="flag6">{{$t('addpet.flag2')}}</span>
        </div>
        <div class="describe">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8}"
            :placeholder="$t('releaseSearch.decription')"
            v-model="textarea2"
            @change="changedescribe"
            @input="word"
            maxlength="200"
          ></el-input>
          <span class="danger" v-show="flag1">{{$t('releaseSearch.notneed')}}</span>
          <span class="wordlimit">{{num}}/200</span>
        </div>
        <div class="time">
          <p>{{$t('releaseSearch.losttime')}}</p>
          <div class="block">
            <el-date-picker
              v-model="losttime"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('releaseSearch.choicetime')"
              :picker-options="pickerOptions"
              @focus="disapper"
              default-time="16:00:00"
              ref="datetime"
            ></el-date-picker>
          </div>
        </div>
        <div class="loseplace">
          <p>{{$t('releaseSearch.lostadr')}}</p>
          <p @click="changeplace">{{place}}</p>
        </div>
        <div class="selectpet">
          <p>{{$t('changefindpetinfo.findPet')}}</p>
          <img :src="petimg">
        </div>
        <div class="petphoto">
          <p>{{$t('releaseSearch.petImg')}}</p>
          <span v-if="imgflag" @click="removeimg">
            <img src="../../image/delete.png" class="delete">
          </span>
          <img :src="imgflag?avatar:avatar1" @click.stop="uploadHeadImg" v-show="isshow">
          <canvas ref="can" v-show="showflag" style="width: 60px;height: 60px;margin-left: 20px;"></canvas>
          <input type="file" accept="image/*" @change="handleFile" class="hiddenInput">
          <span v-if="imgflag1" @click="removeimg1">
            <img src="../../image/delete.png" class="delete1">
          </span>
          <img :src="imgflag1?avatar2:avatar1" @click.stop="uploadHeadImg1" v-show="isshow1">
          <canvas ref="can1" v-show="showflag1" style="width: 60px;height: 60px;margin-left: 20px;"></canvas>
          <input type="file" accept="image/*" @change="handleFile1" class="hiddenInput1">
          <span v-if="imgflag2" @click="removeimg2">
            <img src="../../image/delete.png" class="delete2">
          </span>
          <img :src="imgflag2?avatar3:avatar1" @click.stop="uploadHeadImg2" v-show="isshow2">
          <canvas ref="can2" v-show="showflag2" style="width: 60px;height: 60px;margin-left: 20px;"></canvas>
          <input type="file" accept="image/*" @change="handleFile2" class="hiddenInput2">
        </div>
        <div class="info">
          <span>{{$t('releaseSearch.opencontact')}}</span>
          <el-select
            v-model="value"
            :placeholder="$t('releaseSearch.choice')"
            size="small"
            @change="concat"
            style="width:150px;"
            @focus="isopinfo" @visible-change="opinfo" ref='open'
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <p
            class="danger"
            v-show="flag3"
            style="margin-left:20px;"
          >{{$t('releaseSearch.notcontact')}}</p>
        </div>
        <div class="type">
          <span>{{$t('changefindpetinfo.findStatus')}}</span>
          <el-select
            v-model="value1"
            :placeholder="$t('releaseSearch.choice')"
            size="small"
            style="width:130px;"
            @change="changetype"
            @focus="isinfo" @visible-change="leinfo" ref='info'
          >
            <el-option
              v-for="item in options1"
              :key="item.value1"
              :label="item.label"
              :value="item.value1"
            ></el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          style="margin:20px auto;display: block;width: 80%;"
          @click="save"
          :disabled="issub"
        >{{msg}}</el-button>
      </div>
      
    </div>
    <mapinfo ref="bannerto" @adress="adress"></mapinfo>
  </div>
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import { updatePublish, getpet } from "../../ClientServerApi/index.js";
import headerTop from "../../components/header";
import { getLoginUser } from "../../api/index.js";
import EXIF from "exif-js/exif.js";
import Qs from "qs";
import mapinfo from "../myAccount/mapinfo";
export default {
  name: "changefindpetinfo",
  data() {
    return {
      title: "",
      avatar: "",
      avatar1: require("../../image/addphoto.png"),
      avatar2: "",
      avatar3: "",
      num: "",
      imgflag: false,
      imgflag1: false,
      imgflag2: false,
      flag: false,
      flag1: false,
      flag3: false,
      flag4: true,
      flag5: false,
      flag6: false,
      showflag: false,
      showflag1: false,
      showflag2: false,
      isshow: true,
      isshow1: true,
      isshow2: true,
      issub: false,
      msg: this.$t("changefindpetinfo.commit"),
      cmsg: this.$t("changefindpetinfo.change"),
      personinfo: "",
      featurePhoto: [],
      textarea2: "",
      losttime: "",
      mobile: "",
      email: "",
      place: "",
      petimg: "",
      value: "",
      value1: "",
      petinfo: "",
      isOpen: "",
      options: [
        {
          value: "1",
          label: this.$t("prompt.openemail")
        },
        {
          value: "2",
          label: this.$t("prompt.openphone")
        },
        {
          value: "3",
          label: this.$t("prompt.openall")
        }
      ],
      options1: [
        {
          value1: "1",
          label: this.$t("mysearch.finding")
        },
        {
          value1: "2",
          label: this.$t("mysearch.finded")
        },
        {
          value1: "0",
          label: this.$t("mysearch.closed")
        }
      ],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();//日期选择器控制时间选择范围（今天以前的日期，不包括今天）
        }
      },
      scrollY:0
    };
  },
  components: {
    mapinfo,
    headerTop
  },
  created() {
    this.petinfo = JSON.parse(this.$route.query.petinfo);
    // this.petinfo.loseTime=this.petinfo.loseTime.slice(0,10)

    // console.log('this.petinfo:',this.petinfo)
    // this.petinfo.loseTime=JSON.parse(this.$route.query.petinfo).loseTime.slice(0,10);

    let params = Qs.stringify({ petId: this.petinfo.petId });
    // console.log(this.petinfo.loseTime.slice(0,10))
    getpet(params)
      .then(res => {
        // console.log("获取宠物信息：",res)
        for (var i = 0; i < res.data.data.length; i++) {
          if (this.petinfo.petId == res.data.data[i].petId) {
            this.petimg = res.data.data[i].portrait;
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    getLoginUser()
      .then(res => {
        this.personinfo = res.data.data;
      })
      .catch(error => {
        console.log(error);
      });
      //检验是否登录超时
      if (sessionStorage.getItem("login") == 1) {
        getLoginUser()
          .then(res => {
            if (res.data.header.status == 3019) {
              sessionStorage.setItem("login", "1");
              this.$message({
                type: "success",
                message: this.$t("prompt.header")
              });
              this.$router.push("/login");
            }
          })
          .catch(err => {});
      }
  },
  mounted() {
    this.$refs.wrapper.style.top = this.$refs.title.offsetHeight + 60 + "px";
    // console.log()

    this.$nextTick(() => {
    this._initScroll()
    });
    this.title = this.petinfo.title;
    this.textarea2 = this.petinfo.content;
    this.place = this.petinfo.lostPlace;
    this.num = this.petinfo.content.length;
    this.losttime = this.petinfo.loseTime;
    // console.log("传递的时间：",this.losttime.slice(0,19).replace('T',' '))

    // this.losttime.slice(0,19).indexOf("T")

    // console.log("1", this.petinfo.email);
    // console.log("2", this.petinfo.mobile);
    if (this.petinfo.email != "" && this.petinfo.mobile == "") {
      this.email = this.petinfo.email;
      this.value = this.$t("prompt.openemail");
    }
    if (this.petinfo.email == "" && this.petinfo.mobile != "") {
      this.mobile = this.petinfo.mobile;
      this.value = this.$t("prompt.openphone");
    }
    if (this.petinfo.email != "" && this.petinfo.mobile != "") {
      this.email = this.petinfo.email;
      this.mobile = this.petinfo.mobile;
      this.value = this.$t("prompt.openall");
    }
    if (this.petinfo.firstPhoto) {
      this.imgflag = true;
      this.avatar = this.petinfo.firstPhoto;
      this.featurePhoto.push(JSON.parse(this.petinfo.featurePhoto)[0]);
    }
    if (JSON.parse(this.petinfo.featurePhoto)[1]) {
      this.imgflag1 = true;
      this.avatar2 = JSON.parse(this.petinfo.featurePhoto)[1];
      this.featurePhoto.push(JSON.parse(this.petinfo.featurePhoto)[1]);
    }
    if (JSON.parse(this.petinfo.featurePhoto)[2]) {
      this.imgflag2 = true;
      this.avatar3 = JSON.parse(this.petinfo.featurePhoto)[2];
      this.featurePhoto.push(JSON.parse(this.petinfo.featurePhoto)[2]);
    }
    //console.log("加入图片解析：",JSON.parse(this.petinfo.featurePhoto))
    //console.log("加入图片：",this.featurePhoto)
    if (this.petinfo.isOpen == 1) {
      this.value1 = this.$t("mysearch.finding");
      this.isOpen = 1;
    }
    if (this.petinfo.isOpen == 2) {
      this.value1 = this.$t("mysearch.finded");
      this.isOpen = 2;
    }
    if (this.petinfo.isOpen == 0) {
      this.value1 = this.$t("mysearch.closed");
      this.isOpen = 0;
    }
  },
  methods: {
    _initScroll(){
            this.Scroll = new IScroll(this.$refs.wrapper, {
                click: true,
                probeType: 3
            });
            let self = this
            this.Scroll.on('scroll',function(){
                self.scrollY = this.y
            },true)
        },
    changetitle(e) {
      this.title = e;
      if (this.title.length == 0) {
        this.flag = true;
      } else {
        this.flag = false;
      }
    },
    changedescribe(e) {
      this.textarea2 = e;
      if (this.textarea2.length == 0) {
        this.flag1 = true;
      } else {
        this.flag1 = false;
      }
    },
    changeplace() {
      this.$refs.bannerto.show();
    },
    adress(data) {
      if (data != "") {
        this.place = data;
      }
    },
    word() {
      this.num = this.textarea2.length;
    },
    isinfo(){
      this.Scroll.destroy()
        },
    leinfo(e){
      if(e==false){
            this._initScroll()
            this.Scroll.scrollTo(0, this.scrollY)
            this.$refs.info.blur()
            }
        },
    isopinfo(){
      this.Scroll.destroy()
        },
    opinfo(e){
      if(e==false){
           this._initScroll()
            this.Scroll.scrollTo(0, this.scrollY)
            this.$refs.open.blur()
            }
        },
    disapper() {
      this.$refs.datetime.blur();
    },
    // 打开图片上传
    uploadHeadImg: function() {
      if (this.imgflag == false) {
        this.showflag = false;
        this.isshow = true;
        this.$el.querySelector(".hiddenInput").click();
      }
    },
    // 将头像显示
    handleFile: function(e) {
      var th = this;
      this.imgflag = true;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
      EXIF.getData(file, function() {
        Orientation = EXIF.getTag(this, "Orientation");
      });
      if (file) {
        reader.readAsDataURL(file);
      }
      this.changeflag = true;
      reader.onload = data => {
        let res = data.target || data.srcElement;
        if (data.total < maxSize) {
          th.showflag = false;
          th.isshow = true;
          th.avatar = res.result;
          th.featurePhoto.push(data.target.result.split(",")[1]);
        } else {
          th.compress(res.result, Orientation);
        }
      };
    },
    compress(result, Orientation) {
      var img = new Image();
      var th = this;
      img.src = result;
      th.showflag = true;
      th.isshow = false;
      img.onload = function() {
        var width = img.width;
        var height = img.height;
        var canvas = th.$refs.can;
        var ratio = 400;
        if (width > ratio) {
          var scaling = 1 - (width - ratio) / width;
          width = width * scaling;
          height = height * scaling;
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        if (Orientation != "" && Orientation != 1 && Orientation != undefined) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, width, -height);
              break;
            case 8: //需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((-90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, 0);
              break;
            case 3: //需要180度旋转
              ctx.rotate((180 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, -height);
              break;
          }
        } else {
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        }
        var base64 = canvas.toDataURL("image/jpeg", 0.15);
        th.featurePhoto.push(base64.split(",")[1]);
        th.avatar = base64.result;
      };
    },
    compress1(result, Orientation) {
      var img = new Image();
      var th = this;
      img.src = result;
      th.showflag1 = true;
      th.isshow1 = false;
      img.onload = function() {
        var width = img.width;
        var height = img.height;
        var canvas = th.$refs.can1;
        var ratio = 400;
        if (width > ratio) {
          var scaling = 1 - (width - ratio) / width;
          width = width * scaling;
          height = height * scaling;
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        if (Orientation != "" && Orientation != 1 && Orientation != undefined) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, width, -height);
              break;
            case 8: //需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((-90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, 0);
              break;
            case 3: //需要180度旋转
              ctx.rotate((180 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, -height);
              break;
          }
        } else {
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        }
        var base64 = canvas.toDataURL("image/jpeg", 0.15);
        th.featurePhoto.push(base64.split(",")[1]);
        th.avatar2 = base64.result;
      };
    },
    compress2(result, Orientation) {
      var img = new Image();
      var th = this;
      img.src = result;
      th.showflag2 = true;
      th.isshow2 = false;
      img.onload = function() {
        var width = img.width;
        var height = img.height;
        var canvas = th.$refs.can2;
        var ratio = 400;
        if (width > ratio) {
          var scaling = 1 - (width - ratio) / width;
          width = width * scaling;
          height = height * scaling;
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        if (Orientation != "" && Orientation != 1 && Orientation != undefined) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, width, -height);
              break;
            case 8: //需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((-90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, 0);
              break;
            case 3: //需要180度旋转
              ctx.rotate((180 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, -height);
              break;
          }
        } else {
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        }
        var base64 = canvas.toDataURL("image/jpeg", 0.15);
        th.featurePhoto.push(base64.split(",")[1]);
        th.avatar3 = base64.result;
      };
    },
    // 打开图片上传
    uploadHeadImg1: function() {
      if (this.imgflag1 == false) {
        this.$el.querySelector(".hiddenInput1").click();
      }
    },
    // 将头像显示
    handleFile1: function(e) {
      this.imgflag1 = true;
      var th = this;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
      EXIF.getData(file, function() {
        Orientation = EXIF.getTag(this, "Orientation");
      });
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = data => {
        let res = data.target || data.srcElement;
        if (data.total < maxSize) {
          th.showflag1 = false;
          th.isshow1 = true;
          th.avatar2 = res.result;
          th.featurePhoto.push(data.target.result.split(",")[1]);
        } else {
          th.compress1(res.result, Orientation);
        }
      };
    },
    // 打开图片上传
    uploadHeadImg2: function() {
      if (this.imgflag2 == false) {
        this.$el.querySelector(".hiddenInput2").click();
      }
    },
    // 将头像显示
    handleFile2: function(e) {
      this.imgflag2 = true;
      var th = this;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
      EXIF.getData(file, function() {
        Orientation = EXIF.getTag(this, "Orientation");
      });
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = data => {
        let res = data.target || data.srcElement;
        if (data.total < maxSize) {
          th.showflag2 = false;
          th.isshow2 = true;
          th.avatar3 = res.result;
          th.featurePhoto.push(data.target.result.split(",")[1]);
        } else {
          th.compress2(res.result, Orientation);
        }
      };
    },
    changetype(e) {
      this.isOpen = e;
    },
        disapper() {
            this.$refs.datetime.blur();
        },
        // 打开图片上传
        uploadHeadImg: function() {
            if (this.imgflag == false) {
                this.showflag = false;
                this.isshow = true;
                this.$el.querySelector(".hiddenInput").click();
            }
        },
        // 将头像显示
        handleFile: function(e) {
            var th = this;
            this.imgflag = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            this.changeflag = true;
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag = false;
                    th.isshow = true;
                    th.avatar = res.result;
                    th.featurePhoto.push(data.target.result.split(",")[1]);
                } else {
                    th.compress(res.result, Orientation);
                }
            };
        },
        compress(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag = true;
            th.isshow = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 0.15);
                th.featurePhoto.push(base64.split(",")[1]);
                th.avatar = base64.result;
            };
        },
        compress1(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag1 = true;
            th.isshow1 = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can1;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 0.15);
                th.featurePhoto.push(base64.split(",")[1]);
                th.avatar2 = base64.result;
            };
        },
        compress2(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag2 = true;
            th.isshow2 = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can2;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 0.15);
                th.featurePhoto.push(base64.split(",")[1]);
                th.avatar3 = base64.result;
            };
        },
        // 打开图片上传
        uploadHeadImg1: function() {
            if (this.imgflag1 == false) {
                this.$el.querySelector(".hiddenInput1").click();
            }
        },
        // 将头像显示
        handleFile1: function(e) {
            this.imgflag1 = true;
            var th = this;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag1 = false;
                    th.isshow1 = true;
                    th.avatar2 = res.result;
                    th.featurePhoto.push(data.target.result.split(",")[1]);
                } else {
                    th.compress1(res.result, Orientation);
                }
            };
        },
        // 打开图片上传
        uploadHeadImg2: function() {
            if (this.imgflag2 == false) {
                this.$el.querySelector(".hiddenInput2").click();
            }
        },
        // 将头像显示
        handleFile2: function(e) {
            this.imgflag2 = true;
            var th = this;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag2 = false;
                    th.isshow2 = true;
                    th.avatar3 = res.result;
                    th.featurePhoto.push(data.target.result.split(",")[1]);
                } else {
                    th.compress2(res.result, Orientation);
                }
            };
        },
        changetype(e) {
            this.isOpen = e;
        },
        //删除已选的照片
        removeimg() {
            this.imgflag = false;
            this.showflag = false;
            this.isshow = true;
            this.featurePhoto.splice(0, 1);
        },
        removeimg1() {
            this.imgflag1 = false;
            this.showflag1 = false;
            this.isshow1 = true;
            if(this.featurePhoto.length>=2){
                this.featurePhoto.splice(1, 1);
            }else{
                this.featurePhoto.splice(0,1)
            }

        },
        removeimg2() {
            this.imgflag2 = false;
            this.showflag2 = false;
            this.isshow2 = true;
            if(this.featurePhoto.length==3){
                this.featurePhoto.splice(2, 1);
            }else if(this.featurePhoto.length==2){
                this.featurePhoto.splice(1, 1);
            }else{
                this.featurePhoto.splice(0,1)
            }
            
        },
        concat(e) {
            if (e == 1) {
                this.mobile = "-1";
                if (this.personinfo.email) {
                    this.email = this.personinfo.email;
                    this.flag3 = false;
                } else {
                    this.flag3 = true;
                }
            }
            if (e == 2) {
                this.email = "-1";
                if (this.personinfo.mobile) {
                    this.mobile = this.personinfo.mobile;
                    this.flag3 = false;
                } else {
                    this.flag3 = true;
                }
            }
            if (e == 3) {
                if (this.personinfo.mobile && this.personinfo.email) {
                    this.email = this.personinfo.email;
                    this.mobile = this.personinfo.mobile;
                    this.flag3 = false;
                } else {
                    this.flag3 = true;
                }
            }
        },
        save() {
            if (this.featurePhoto.length == 0) {
                this.flag5 = true;
                this.$message({
                  type: "error",
                  message: this.$t("changefindpetinfo.failure")
                });
            }
            if (this.flag5 == false) {
              // let timeChange = this.losttime.slice(0,19).replace('T',' ');
              // console.log("改变获取时间的格式：",timeChange)
              // console.log("上传图片格式：",JSON.stringify(this.featurePhoto).slice(1,JSON.stringify(this.featurePhoto).length-1))
              let pic='';
              for(var i=0;i<this.featurePhoto.length;i++){
                if(i>0){
                  pic+=",";
                }
                pic+=this.featurePhoto[i];
              }
              // console.log("pic",pic)
                setTimeout(() => {
                    this.msg = this.cmsg;
                    this.issub = true;
                    let params = Qs.stringify({
                        publishId: this.petinfo.id,
                        loseTime: this.losttime.slice(0,19).replace('T',' '),
                        lostPlace: this.place,
                        // featurePhoto: JSON.stringify(this.featurePhoto),
                        featurePhoto: pic,
                        content: this.textarea2,
                        isOpen: this.isOpen,
                        email: this.email,
                        mobile: this.mobile,
                        title:this.title
                    });
                    // console.log("params:",params)
                    updatePublish(params)
                        .then(res => {
                            console.log(res);
                            if (res.data.header.status == 1000) {
                              console.log("修改成功：",res.data.header.status)
                                this.issub = false;
                                this.$router.push("/mysearch");
                            } else {
                                this.$message({
                                    type: "error",
                                    message: this.$t(
                                        "changefindpetinfo.failure"
                                    )
                                });
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }, 100);
            }
        }
    }
  }
</script>
<style>
.el-message {
  min-width: 60%;
}
.title .el-input__inner {
  font-size: 0.75rem;
  border-top-color: white;
  border-right-color: white;
  border-left-color: white;
}
.title .el-input__inner:hover {
  border-top-color: white;
  border-right-color: white;
  border-left-color: white;
}
.changefindpetinfo .el-textarea__inner {
  font-size: 0.75rem;
  border-top-color: white;
  border-right-color: white;
  border-left-color: white;
}
.changefindpetinfo .el-button--primary {
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 30px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  text-align: center;
  color: #ffffff;
  padding: 0 0;
}
.changefindpetinfo .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  margin-left: 20px;
}
</style>
<style scoped>
.changefindpetinfo .danger {
  font-size: 0.625rem;
  color: red;
  margin-top: 5px;
}
.el-message-box {
  width: 80%;
}
.hiddenInput {
  display: none;
}
.hiddenInput1 {
  display: none;
}
.hiddenInput2 {
  display: none;
}

.loseplace {
  border-bottom: solid 1px rgb(230, 230, 230);
}
.loseplace p {
  font-size: 0.875rem;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.loseplace p:nth-child(2) {
  font-size: 0.75rem;
  margin-left: 20px;
  margin-top: 15px;
  margin-bottom: 10px;
}
.time p {
  font-size: 0.875rem;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.wordlimit {
  font-size: 0.625rem;
  position: absolute;
  right: 20px;
}
.main {
  position: absolute;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  touch-action: none;
}
.addtext {
  text-align: center;
  font-size: 1rem;
  color: rgb(130, 130, 130);
  letter-spacing: 1px;
  padding: 20px 0;
}
.title {
  margin-top: 15px;
  width: 90%;
  margin: 0 auto;
}
.describe {
  width: 90%;
  margin: 0 auto;
}
.selectpet p {
  font-size: 0.875rem;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.petphoto .delete {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 20px;
  left: -5px;
}
.petphoto .delete1 {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 20px;
  left: 78px;
}
.petphoto .delete2 {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 20px;
  left: 163px;
}
.selectpet img {
  width: 60px;
  height: 60px;
  margin-left: 20px;
}
.petphoto {
  border-bottom: solid 1px rgb(230, 230, 230);
  padding-bottom: 10px;
  position: relative;
}
.petphoto p {
  font-size: 0.875rem;
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.petphoto img {
  width: 60px;
  height: 60px;
  margin-left: 20px;
  object-fit:cover;
}
.info {
  margin: 15px 0;
}
.info span {
  font-size: 0.875rem;
  margin-left: 20px;
}
.type {
  margin: 15px 0;
}
.type span {
  font-size: 0.875rem;
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/m_page/myAccount/changefindpetinfo.vue